import {
  BrandSubscriptionPaymentFrequency,
  BrandSubscriptionPlatform,
  BrandSubscriptionTier,
} from '../brand-subscription/constants'
import {Jurisdiction} from '../countries/constants'
import {currencies, Currency} from '../currency'
import {MonitoringPriceSheetKey, Prices, PricesGroup, WithBreakpoints} from './types'
import {PRICE_CONFIGS} from './use-in-commerce-request/constants'

const emptyCurrencies: Record<Currency, number> = Object.fromEntries(
  Object.values(currencies).map((currency) => [currency, 0]),
) as Record<Currency, number>

const emptyPriceGroupJurisdiction: PricesGroup<Jurisdiction> = Object.fromEntries(
  Object.values(Jurisdiction).map((jurisdiction) => [jurisdiction, emptyCurrencies]),
) as PricesGroup<Jurisdiction>

const emptyPriceGroupWithBreakpoints: WithBreakpoints<PricesGroup<string>, Jurisdiction> = {
  breakpoints: Object.fromEntries(
    Object.values(Jurisdiction).map((jurisdiction) => [jurisdiction, [] as number[]]),
  ) as Record<Jurisdiction, number[]>,
} as WithBreakpoints<PricesGroup<string>, Jurisdiction>

const gatherUseInCommerceKeys = (obj: any): string[] =>
  Object.values(obj).flatMap((value) =>
    typeof value === 'string'
      ? [value]
      : typeof value === 'object'
      ? gatherUseInCommerceKeys(value)
      : [],
  )

const emptyUseInCommerce = Object.fromEntries(
  gatherUseInCommerceKeys(PRICE_CONFIGS).map((key) => [key, emptyCurrencies]),
)

const emptyMonitoring = Object.fromEntries(
  [
    ...Object.values(BrandSubscriptionTier).map((tier) => tier.replace('v2-', '')),
    ...Object.values(BrandSubscriptionPlatform),
  ].flatMap((platform) =>
    Object.values(BrandSubscriptionPaymentFrequency).map((frequency) => [
      `${platform}-${frequency}` as MonitoringPriceSheetKey,
      emptyCurrencies,
    ]),
  ),
) as PricesGroup<MonitoringPriceSheetKey>

export const pricesEmpty: Prices = {
  registrationFees: emptyPriceGroupJurisdiction,
  categoryFees: emptyPriceGroupWithBreakpoints,
  registrationMargins: emptyPriceGroupJurisdiction,
  categoryMargins: emptyPriceGroupWithBreakpoints,
  partnerFees: emptyPriceGroupJurisdiction,
  partnerCategoryFees: emptyPriceGroupWithBreakpoints,
  extraItems: emptyPriceGroupJurisdiction,
  renewalRegistrationFees: emptyPriceGroupJurisdiction,
  renewalCategoryFees: emptyPriceGroupWithBreakpoints,
  renewalRegistrationMargins: emptyPriceGroupJurisdiction,
  renewalCategoryMargins: emptyPriceGroupWithBreakpoints,
  assignmentRegistrationFees: emptyPriceGroupJurisdiction,
  assignmentCategoryFees: emptyPriceGroupWithBreakpoints,
  assignmentRegistrationMargins: emptyPriceGroupJurisdiction,
  assignmentCategoryMargins: emptyPriceGroupWithBreakpoints,
  useInCommerceRequestFilingFees: emptyUseInCommerce,
  useInCommerceRequestServiceFees: emptyUseInCommerce,
  otherServiceMargins: {},
  otherServiceRegistrationFees: {},
  monitoring: emptyMonitoring,
  enforcementServiceFees: {},
  enforcementFilingFees: {},
  wipoFilingFees: {},
  wipoFilingCategoryFees: emptyPriceGroupWithBreakpoints,
  wipoServiceFees: {},
  wipoServiceCategoryFees: emptyPriceGroupWithBreakpoints,
}
